import { getFieldOptionsForSelect } from '../pluginComponentApi';
import { FieldTypes } from 'drapcode-constant';
import { getFieldsTraits } from '../../apiUtils';

const filterHrefTraitsOption = (fieldOptions, fieldType) => {
  console.log('fieldOptions filterHrefTraitsOption', fieldOptions);
  return fieldOptions.filter((field) => {
    const fieldMetaData = field.metaData ? JSON.parse(field.metaData) : '';
    console.log('FieldTypes.uuid.id', fieldType);
    return (fieldMetaData && fieldMetaData.fieldType === fieldType) || field.type === fieldType;
  });
};
export const getPathFieldOptions = async (
  selectedPageCollection,
  projectId,
  version,
  dataGroupFieldOptions,
  dataGroupCollectionId,
  collections,
) => {
  let pageCollection = '';
  if (selectedPageCollection && selectedPageCollection !== 'undefined' && projectId) {
    pageCollection = await getFieldsTraits(selectedPageCollection, projectId, version, collections);
  }
  console.log('pageCollection getPathFieldOptions', pageCollection);
  const pageCollectionOptions = pageCollection ? pageCollection.options : [];
  let fieldOptions = dataGroupFieldOptions || pageCollectionOptions;
  console.log('dataGroupCollectionId getPathFieldOptions', dataGroupCollectionId);
  let collectionId = dataGroupCollectionId
    ? dataGroupCollectionId
    : pageCollection
    ? pageCollection.collectionId
    : '';
  fieldOptions = filterHrefTraitsOption(fieldOptions, FieldTypes.uuid.id);
  console.log('fieldOptions getPathFieldOptions', fieldOptions);
  console.log('collectionId getPathFieldOptions', collectionId);
  return getSelectOptionsOfPathFields(fieldOptions, collectionId);
};

export const getSEOFieldOptions = async (
  selectedPageCollection,
  projectId,
  version,
  dataGroupFieldOptions,
  dataGroupCollectionId,
) => {
  let pageCollection = '';
  console.log('version getSEOFieldOptions hrefTrait', version);
  if (selectedPageCollection && selectedPageCollection !== 'undefined' && projectId) {
    pageCollection = await getFieldsTraits(selectedPageCollection, projectId, version, null);
  }
  const pageCollectionOptions = pageCollection ? pageCollection.options : [];
  let fieldOptions = dataGroupFieldOptions || pageCollectionOptions;
  let collectionId = dataGroupCollectionId
    ? dataGroupCollectionId
    : pageCollection
    ? pageCollection.collectionId
    : '';
  fieldOptions = fieldOptions.filter((field) => {
    const fieldMetaData = field.metaData ? JSON.parse(field.metaData) : '';
    return field.type === FieldTypes.text.id;
  });
  return getSelectOptionsOfPathFields(fieldOptions, collectionId);
};

const getSelectOptionsOfPathFields = (fieldOptions, collectionId) => {
  let optionHtml = `<option value="">None</option>`;
  console.log('fieldOptions getSelectOptionsOfPathFields', fieldOptions);
  optionHtml += fieldOptions
    .map((opt) => {
      let collectionName = collectionId;
      if (opt.metaData) {
        console.log('Meta Data In link traits:::', JSON.parse(opt.metaData));
        collectionName = JSON.parse(opt.metaData).collectionName;
      }
      console.log('collectionName getSelectOptionsOfPathFields', collectionName);
      console.log('opt.id getSelectOptionsOfPathFields', opt.id);
      if (opt.id === 'uuid') {
        return `<option value="${
          opt.id
        }" selected  data-collectionId="${collectionName}" metaData= "${
          opt.metaData ? opt.metaData.split('"').join("'") : ''
        }" type="${opt.type}">${opt.name}</option>`;
      } else {
        return `<option value="${opt.id}"  data-collectionId="${collectionName}"  metaData= "${
          opt.metaData ? opt.metaData.split('"').join("'") : ''
        }" type="${opt.type}">${opt.name}</option>`;
      }
    })
    .join('');
  return optionHtml;
};

export const setPathAndSeoFieldOptionsAccrodingToHrefFrom = async (
  component,
  inputPathField,
  inputPathSEO,
  projectId,
  version,
  pageCollection,
  session,
  selectGetHrefCollectionIdFromValue,
  collections,
  browserStorageKeyValue,
) => {
  console.log('\n component :>> ', component);
  //Finding parent CMS collection
  console.log('\n browserStorageKeyValue :>> ', browserStorageKeyValue);
  console.log('\n version hrefTrait:>> ', version);

  const dataTable = component.closestType('data-table');
  const dataGroup = component.closestType('data-group');
  let cmsCollectionName = '';
  if (dataTable) {
    cmsCollectionName = dataTable.get('collectionName');
  } else if (dataGroup) {
    cmsCollectionName = dataGroup.get('collectionName');
  }

  if (selectGetHrefCollectionIdFromValue === 'session') {
    inputPathField.innerHTML = await getPathFieldOptions(
      '',
      projectId,
      version,
      session ? session.options : [],
      session ? session.collectionId : [],
    );
    inputPathSEO.innerHTML = await getSEOFieldOptions(
      '',
      projectId,
      version,
      session ? session.options : [],
      session ? session.collectionId : [],
    );
  } else if (selectGetHrefCollectionIdFromValue === 'pageCollection') {
    inputPathField.innerHTML = await getPathFieldOptions(
      '',
      projectId,
      version,
      pageCollection ? pageCollection.options : [],
      pageCollection ? pageCollection.collectionId : '',
    );
    inputPathSEO.innerHTML = await getSEOFieldOptions(
      '',
      projectId,
      version,
      pageCollection ? pageCollection.options : [],
      pageCollection ? pageCollection.collectionId : '',
    );
  } else if (selectGetHrefCollectionIdFromValue === 'parentCollection') {
    inputPathField.innerHTML = await getPathFieldOptions(
      cmsCollectionName || '',
      projectId,
      version,
      '',
      '',
      collections,
    );
    inputPathSEO.innerHTML = await getSEOFieldOptions(
      cmsCollectionName || '',
      projectId,
      version,
      '',
      '',
      collections,
    );
  } else if (selectGetHrefCollectionIdFromValue === 'browserStorage') {
    inputPathField.innerHTML = await getPathFieldOptions(
      browserStorageKeyValue,
      projectId,
      version,
      '',
      '',
      collections,
    );
    inputPathSEO.innerHTML = await getSEOFieldOptions(
      browserStorageKeyValue,
      projectId,
      version,
      '',
      '',
      collections,
    );
  } else {
    inputPathField.innerHTML = `<option value="">None</option>`;
    inputPathSEO.innerHTML = `<option value="">None</option>`;
  }
};

export const getCollectionUrlFieldOptions = async (projectId, version, component, collections) => {
  const dataTable = component.closestType('data-table');
  const dataGroup = component.closestType('data-group');
  let cmsCollectionName = '';
  if (dataTable) {
    cmsCollectionName = dataTable.get('collectionName');
  } else if (dataGroup) {
    cmsCollectionName = dataGroup.get('collectionName');
  }
  let collection = '';
  if (cmsCollectionName && cmsCollectionName !== 'undefined' && projectId) {
    collection = await getFieldsTraits(cmsCollectionName, projectId, version, collections);
  }
  let collectionOptions = collection ? collection.options : [];
  let collectionId = collection ? collection.collectionId : '';
  collectionOptions = filterHrefTraitsOption(collectionOptions, FieldTypes.url.id);
  return getSelectOptionsOfPathFields(collectionOptions, collectionId);
};
